export default [
  {
    component: () => import('../pages/spvs/onboarding.vue'),
    name: 'investing.spv-new',
    path: '/:slug/investing/spvs/new',
  },
  {
    component: () => import('../pages/spvs/onboarding.vue'),
    name: 'investing.spv-edit',
    path: '/:slug/investing/spv/:entity_id/edit',
  },
  {
    // The converged deal-creation wizard (tickets/2866) — ONE flow for every
    // deal kind. The entity-generic path (the entity-overview convention)
    // carries the vehicle kind; the company variant lives under
    // companies.deal_new. The former per-kind routes and the standalone
    // company-selection gates collapsed into this page: selection is the
    // wizard's first step when the link doesn't exist yet, and a threaded
    // `?company_id=` (fund profile Set Up Fund flow) preselects it.
    component: () => import('@/modules/deals/pages/deal-create-page.vue'),
    name: 'investing.deal_new',
    path: '/:slug/investing/:entity_type/:entity_id/deal/new',
  },
  {
    // Edit mode of the same wizard: prefills from the existing deal card and
    // saves via the same upsert endpoint.
    component: () => import('@/modules/deals/pages/deal-create-page.vue'),
    name: 'investing.deal_edit',
    path: '/:slug/investing/:entity_type/:entity_id/deal/edit',
  },
  {
    component: () => import('../pages/spvs/onboarding-document.vue'),
    name: 'investing.spv.onboarding-document',
    path: '/:slug/investing/spv/:entity_id/onboarding-document',
  },
  {
    component: () => import('../pages/funds/onboarding.vue'),
    name: 'investing.fund-new',
    path: '/:slug/investing/funds/new',
  },
  {
    component: () => import('../pages/funds/onboarding.vue'),
    name: 'investing.fund-edit',
    path: '/:slug/investing/fund/:entity_id/edit',
  },
  {
    component: () => import('../pages/individuals/[individualId].vue'),
    name: 'individuals.overview',
    path: '/:slug/investing/individuals/:individual_id',
  },
  {
    component: () => import('../pages/individuals/[individualId]/invoices/index.vue'),
    name: 'individuals.invoices',
    path: '/:slug/investing/individuals/:individual_id/invoices',
  },
  {
    component: () => import('../pages/individuals/[individualId]/portfolio/index.vue'),
    name: 'individuals.portfolio',
    path: '/:slug/investing/individuals/:individual_id/portfolio',
  },
  {
    component: () => import('../pages/entities/[entityId]/transactions/index.vue'),
    name: 'investing.transactions',
    path: '/:slug/investing/:entity_type/:entity_id/transactions',
  },
  {
    component: () => import('../pages/entities/[entityId]/transactions/new.vue'),
    name: 'investing.transactions.new',
    path: '/:slug/investing/:entity_type/:entity_id/transactions/new',
  },
  {
    component: () => import('../pages/entities/[entityId]/transactions/edit.vue'),
    name: 'investing.transactions.edit',
    path: '/:slug/investing/:entity_type/:entity_id/transactions/:batch_transaction_id/edit',
  },
  {
    component: () => import('../pages/entities/[entityId]/calls/edit.vue'),
    name: 'investing.capital-call.edit',
    path: '/:slug/investing/:entity_type/:entity_id/calls/:capital_call_id/edit',
  },
  {
    component: () => import('../pages/entities/[entityId]/calls/new.vue'),
    name: 'investing.capital-call.new',
    path: '/:slug/investing/:entity_type/:entity_id/calls/new',
  },
  {
    component: () => import('../pages/disbursement-edit-page.vue'),
    name: 'investing.disbursement.edit',
    path: '/:slug/investing/:entity_type/:entity_id/distributions/:disbursement_id/edit',
  },
  {
    component: () => import('../pages/disbursement-new-page.vue'),
    name: 'investing.disbursement.new',
    path: '/:slug/investing/:entity_type/:entity_id/distributions/new',
  },
  {
    component: () => import('../pages/document-new-page.vue'),
    name: 'investing.document.new',
    path: '/:slug/investing/document/new',
  },
  {
    component: () => import('../pages/documents-page.vue'),
    name: 'investing.documents',
    path: '/:slug/investing/documents',
  },
  {
    component: () => import('../pages/entities-page.vue'),
    name: 'investing.entities',
    path: '/:slug/investing/:entity_type',
  },
  {
    component: () => import('../pages/entities/[entityId]/capitalAccount/index.vue'),
    name: 'investing.entity.capital-account',
    path: '/:slug/investing/:entity_type/:entity_id/capital_account',
  },
  {
    component: () => import('../pages/entity-documents-page.vue'),
    name: 'investing.entity.documents',
    path: '/:slug/investing/:entity_type/:entity_id/documents',
  },
  {
    component: () => import('../pages/entities/[entityId]/notes/index.vue'),
    name: 'investing.entity.notes',
    path: '/:slug/investing/:entity_type/:entity_id/notes',
  },
  {
    component: () => import('../pages/entities/[entityId]/account/index.vue'),
    name: 'investing.entity.account',
    path: '/:slug/investing/:entity_type/:entity_id/account',
    beforeEnter: (to) => {
      // SPVs and funds render the account settings page (#2991/#3052); GPs
      // keep the SPV wizard they used before it.
      if (to.params.entity_type === 'gp') {
        return {
          name: 'investing.spv-edit',
          params: { slug: to.params.slug as string, entity_id: to.params.entity_id as string },
        }
      }
    },
  },
  {
    component: () => import('../pages/entity-document-new-page.vue'),
    name: 'investing.entity.document.new',
    path: '/:slug/investing/:entity_type/:entity_id/document/new',
  },
  {
    component: () => import('../pages/entities/[entityId].vue'),
    name: 'investing.entity-overview',
    path: '/:slug/investing/:entity_type/:entity_id/overview',
  },
  // The fund Profile tab is gone (tickets/3184): every vehicle surface
  // lives on the overview, which renders the raising profile body itself.
  {
    component: () => import('../pages/individuals-page.vue'),
    name: 'investing.individuals',
    path: '/:slug/investing/individuals',
  },
  {
    component: () => import('../pages/individual-documents-page.vue'),
    name: 'investing.individual.documents',
    path: '/:slug/investing/individual/:individual_id/documents',
  },
  {
    component: () => import('../pages/individuals/[individualId]/invoices/index.vue'),
    name: 'investing.individual-invoices',
    path: '/:slug/investing/individual/:individual_id/invoices',
  },
  {
    component: () => import('../pages/individual-onboarding-page.vue'),
    name: 'investing.individual.onboarding',
    path: '/:slug/investing/individual/:individual_id/onboarding',
  },
  {
    component: () => import('../pages/individuals/[individualId].vue'),
    name: 'investing.individual-overview',
    path: '/:slug/investing/individual/:individual_id/overview',
  },
  {
    component: () => import('../pages/individuals/[individualId]/accreditation/index.vue'),
    name: 'investing.individual.accreditation',
    path: '/:slug/investing/individual/:individual_id/accreditation',
  },
  {
    component: () => import('../pages/individuals/[individualId]/permissions/index.vue'),
    name: 'investing.individual.permissions',
    path: '/:slug/investing/individual/:individual_id/permissions',
  },
  {
    component: () => import('../pages/individuals/[individualId]/beneficiaries/index.vue'),
    name: 'investing.individual.beneficiaries',
    path: '/:slug/investing/individual/:individual_id/beneficiaries',
  },
  {
    component: () => import('../pages/individuals/[individualId]/contacts/index.vue'),
    name: 'investing.individual.contacts',
    path: '/:slug/investing/individual/:individual_id/contacts',
  },
  {
    component: () => import('../pages/individuals/[individualId]/loginInformation.vue'),
    name: 'investing.individual.login-information',
    path: '/:slug/investing/individual/:individual_id/login-information',
  },
  {
    component: () => import('../pages/individuals/[individualId]/investmentPreferences/index.vue'),
    name: 'investing.individual.investment-preferences',
    path: '/:slug/investing/individual/:individual_id/investment-preferences',
    redirect: (to) => ({ name: 'investing.individual-overview', params: to.params }),
  },
  {
    component: () => import('../pages/individuals/[individualId]/funds/index.vue'),
    name: 'investing.individual.funds',
    path: '/:slug/investing/individual/:individual_id/funds',
  },
  {
    component: () => import('../pages/individuals/[individualId]/spvs/index.vue'),
    name: 'investing.individual.spvs',
    path: '/:slug/investing/individual/:individual_id/spvs',
  },
  {
    component: () => import('../pages/individuals/[individualId]/associated-entities/index.vue'),
    name: 'investing.individual.associated-entities',
    path: '/:slug/investing/individual/:individual_id/associated-entities',
  },
  {
    component: () => import('../pages/individuals/[individualId]/taxes/index.vue'),
    name: 'investing.individual.taxes',
    path: '/:slug/investing/individual/:individual_id/taxes',
  },
  {
    component: () => import('../pages/individuals/[individualId]/account/index.vue'),
    name: 'investing.individual.account',
    path: '/:slug/investing/individual/:individual_id/account',
  },
  {
    component: () => import('../pages/individuals/[individualId]/notes/index.vue'),
    name: 'investing.individual.notes',
    path: '/:slug/investing/individual/:individual_id/notes',
  },
  {
    component: () => import('../pages/individual-disbursement-preferences-page.vue'),
    name: 'investing.individual.disbursement-preferences',
    path: '/:slug/investing/individual/:individual_id/disbursement-preferences',
  },
  {
    component: () => import('../pages/individuals-import-page.vue'),
    name: 'investing.individuals.import',
    path: '/:slug/investing/individuals/import',
  },
  {
    component: () => import('../pages/entities/[entityId]/investors/index.vue'),
    name: 'investing.investors',
    path: '/:slug/investing/:entity_type/:entity_id/investors',
  },
  {
    component: () => import('../pages/invoices-page.vue'),
    name: 'investing.invoices',
    path: '/:slug/investing/invoices',
  },
  {
    component: () => import('../pages/other-entities-page.vue'),
    name: 'investing.associated-entities',
    path: '/:slug/investing/associated-entities',
  },
  {
    component: () => import('../pages/associatedEntities/[associatedEntityId]/esignatures/index.vue'),
    name: 'investing.associated-entity.documents',
    path: '/:slug/investing/associated-entity/:associated_entity_id/documents',
  },
  {
    component: () => import('../pages/associatedEntities/[associatedEntityId]/notes/index.vue'),
    name: 'investing.associated-entity.notes',
    path: '/:slug/investing/associated-entity/:associated_entity_id/notes',
  },
  {
    component: () => import('../pages/other-entity-edit-page.vue'),
    name: 'investing.associated-entity.edit',
    path: '/:slug/investing/associated-entity/:associated_entity_id/edit',
  },
  {
    component: () => import('../pages/associatedEntities/[associatedEntityId]/invoices/index.vue'),
    name: 'investing.associated-entity.invoices',
    path: '/:slug/investing/associated-entity/:associated_entity_id/invoices',
  },
  {
    component: () => import('../pages/associatedEntities/[associatedEntityId]/investors/index.vue'),
    name: 'investing.associated-entity.investors',
    path: '/:slug/investing/associated-entity/:associated_entity_id/investors',
  },
  {
    component: () => import('../pages/other-entity-new-page.vue'),
    name: 'investing.associated-entity.new',
    path: '/:slug/investing/associated-entity/new',
  },
  {
    component: () => import('../pages/associatedEntities/[associatedEntityId].vue'),
    name: 'investing.associated-entity.overview',
    path: '/:slug/investing/associated-entity/:associated_entity_id/overview',
  },
  {
    component: () => import('../pages/associatedEntities/[associatedEntityId]/portfolio/index.vue'),
    name: 'investing.associated-entity.portfolio',
    path: '/:slug/investing/associated-entity/:associated_entity_id/portfolio',
  },
  {
    component: () => import('../pages/associatedEntities/[associatedEntityId]/funds/index.vue'),
    name: 'investing.associated-entity.funds',
    path: '/:slug/investing/associated-entity/:associated_entity_id/funds',
  },
  {
    component: () => import('../pages/associatedEntities/[associatedEntityId]/spvs/index.vue'),
    name: 'investing.associated-entity.spvs',
    path: '/:slug/investing/associated-entity/:associated_entity_id/spvs',
  },
  {
    component: () => import('../pages/associatedEntities/[associatedEntityId]/associated-entities/index.vue'),
    name: 'investing.associated-entity.associated-entities',
    path: '/:slug/investing/associated-entity/:associated_entity_id/associated-entities',
  },
  {
    component: () => import('../pages/associatedEntities/[associatedEntityId]/account/index.vue'),
    name: 'investing.associated-entity.account',
    path: '/:slug/investing/associated-entity/:associated_entity_id/account',
  },
  {
    component: () => import('../pages/admins-page.vue'),
    name: 'investing.admins',
    path: '/:slug/investing/admins',
  },
  {
    component: () => import('../pages/subgroups-page.vue'),
    name: 'investing.subgroups',
    path: '/:slug/investing/subgroups',
  },
  {
    component: () => import('../pages/subgroup-overview-page.vue'),
    name: 'investing.subgroup-overview',
    path: '/:slug/investing/subgroup/:subgroup_id/overview',
  },
  {
    component: () => import('../pages/ownership-transfers-page.vue'),
    name: 'investing.transfers',
    path: '/:slug/investing/:entity_type/:entity_id/transfers',
  },
  {
    component: () => import('../pages/portfolio-page.vue'),
    name: 'investing.portfolio',
    path: '/:slug/portfolio',
  },
  {
    component: () => import('../pages/individuals/[individualId]/portfolio/index.vue'),
    name: 'investing.individual.portfolio',
    path: '/:slug/investing/individual/:individual_id/portfolio',
  },
  {
    component: () => import('../pages/entities/[entityId]/portfolio/index.vue'),
    name: 'investing.entity.portfolio',
    path: '/:slug/investing/:entity_type/:entity_id/portfolio',
  },
  {
    component: () => import('../pages/spv-overview-v2.vue'),
    name: 'spv-overview-v2',
    path: '/spv-overview-v2',
  },
  {
    path: '/:slug/investing/:entity_type/:entity_id',
    redirect: (to) => {
      return { name: 'investing.entity-overview', params: to.params }
    },
  },
  {
    path: '/:slug/investing/individual/:individual_id',
    redirect: (to) => {
      return { name: 'investing.individual-overview', params: to.params }
    },
  },
  {
    path: '/:slug/investing/associated-entity/:associated_entity_id',
    redirect: (to) => {
      return { name: 'investing.associated-entity.overview', params: to.params }
    },
  },
]
